import Benefits from '@/views/benefit/Benefits.vue'
import FormBenefit from '@/views/benefit/FormBenefit.vue'

const benefitsRouter = (beforeEnter) => {
    return [
        {
            beforeEnter: beforeEnter,
            name: 'Clube',
            path: '/clube',
            meta: {
                requiresAuth: true,
                isEmployee: true,
                breadcrumb: true,
                breadcrumbName: 'Clube',
                layout: 'default'
            },
            component: Benefits
        },
        {
            beforeEnter: beforeEnter,
            name: 'CadastrarBeneficio',
            path: '/clube/beneficio/cadastrar',
            meta: {
                requiresAuth: true,
                isEmployee: true,
                breadcrumb: true,
                breadcrumbName: 'Cadastrar Beneficio',
                layout: 'default'
            },
            component: FormBenefit
        },
        {
            beforeEnter: beforeEnter,
            name: 'EditarBeneficio',
            path: '/clube/beneficio/editar/:id',
            meta: {
                requiresAuth: true,
                isEmployee: true,
                breadcrumb: true,
                breadcrumbName: 'Editar Beneficio',
                layout: 'default'
            },
            component: FormBenefit
        }
    ]
}

export default benefitsRouter
